import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { PerforatedService } from "src/app/modules/slotted-perforated-pipe/perforated-pipe/services/perforated.service";
import { GeothermalService } from "src/app/modules/geothermal/services/geothermal.service";
import { Datasheet } from "src/app/modules/slotted-perforated-pipe/shared/slotted-modal/models/dcp-modal";
import { SlottedService } from "src/app/modules/slotted-perforated-pipe/slotted-pipe/services/slotted.service";
import { SlottedModalService } from "../../services/slotted-modal.service";

@Component({
  selector: "app-dcp-table",
  templateUrl: "./dcp-table.component.html",
  styleUrls: ["./dcp-table.component.css"],
})


export class DcpTableComponent implements OnInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @Input() selectedProduct: Datasheet | null = null;
  @Output() rowSelected = new EventEmitter<Datasheet>();
  @Output() loadProduct = new EventEmitter<Datasheet>();
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  isDtInitialized: boolean = false;

  dcpProducts: Datasheet[];

  constructor(
    private slottedModalService: SlottedModalService,
    private slottedService: SlottedService,
    private perforatedService: PerforatedService,
    private geothermalService: GeothermalService
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      language: {
        emptyTable:
          "Please select outside diameter and wall thickness to view products",
      },
      pagingType: "simple_numbers",
      pageLength: 10,
      lengthMenu: [[5, 10, 25], [5, 10, 25]],
      order: [[0, "asc"]],
      autoWidth: true,
    };

    this.slottedModalService.dcpProducts$.subscribe((dcpProducs) => {
      this.dcpProducts = dcpProducs;
      if (this.isDtInitialized) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
      } else {
        this.isDtInitialized = true;
        this.dtTrigger.next();
      }
    });
  }

  selectRow(dcpProduct: Datasheet) {
    this.rowSelected.emit(dcpProduct);
  }

  onDoubleClick(dcpProduct: Datasheet) {
    this.rowSelected.emit(dcpProduct);
    this.loadProduct.emit(dcpProduct);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
